import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { api } from "../../lib/api";

export const SubmitReportDialog = ({ req, onOpenChange, onDone }) => {
  const [due, setDue] = useState("");
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);
  const [names, setNames] = useState([]);
  const ref = useRef(null);
  useEffect(() => { if (req) { setDue(req.overdue?.[0] || req.next_due || ""); setNotes(""); setNames([]); } }, [req]);
  const send = async () => {
    const files = [...(ref.current?.files || [])];
    if (!files.length && !notes.trim()) { toast.warning("أرفق ملف التقرير أو اكتب محتواه"); return; }
    setBusy(true);
    try {
      await api.submitReport(req.id, due, notes, files);
      toast.success("تم إرسال التقرير وحفظ نسخة في مكتبة الشركة ← التقارير");
      onDone(); onOpenChange(false);
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الإرسال"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!req} onOpenChange={onOpenChange}>
      <DialogContent dir="rtl" className="sm:max-w-md" data-testid="submit-report-dialog">
        <DialogHeader className="text-start"><DialogTitle>رفع تقرير: {req?.title}</DialogTitle>
          <DialogDescription>{req?.department_name}</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label>عن موعد (يمكن اختيار تاريخ سابق)</Label>
            <Input type="date" value={due} onChange={(e) => setDue(e.target.value)} data-testid="sr-due" />
            {(req?.overdue?.length || 0) > 0 && <div className="flex flex-wrap gap-1">{req.overdue.map((d) => (
              <button key={d} type="button" onClick={() => setDue(d)} className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${due === d ? "bg-rose-600 text-white" : "bg-rose-50 text-rose-700"}`} data-testid={`sr-overdue-${d}`}>متأخر {d}</button>))}</div>}
          </div>
          <div className="space-y-1.5"><Label>الملفات (PDF، Excel، Word، صور)</Label>
            <input ref={ref} type="file" multiple className="hidden" onChange={(e) => setNames([...e.target.files].map((f) => f.name))} data-testid="sr-files" />
            <button type="button" onClick={() => ref.current?.click()} className="flex w-full items-center gap-2 rounded-md border border-dashed border-slate-300 px-3 py-2 text-sm text-slate-600 hover:border-emerald-400" data-testid="sr-files-btn">
              <Upload className="h-4 w-4" /> {names.length ? names.join("، ") : "اختر الملفات"}</button></div>
          <div className="space-y-1.5"><Label>ملاحظات / ملخص التقرير</Label><Textarea rows={4} value={notes} onChange={(e) => setNotes(e.target.value)} data-testid="sr-notes" /></div>
          <Button className="w-full gap-1.5 bg-emerald-600 hover:bg-emerald-700" disabled={busy || !due} onClick={send} data-testid="sr-send">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} إرسال التقرير
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
